import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import commonFunctions from '../../../utils/commonFunctions';
import { SIGNAGE_MEDIA } from '../../../utils/constants';

const TickerMessage = ({
  setSuccess,
  closeModal,
  setZoneData,
  tickerMessageData,
  zone,
  setZone,
  markUnsavedChanges
}) => {

  const [tickerMessage, setTickerMessage] = useState('');
  const [tickerMessageValid, setTickerMessageValid] = useState('');
  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const MAX_CHARACTERS = 256;
  /**
    * Reset modal
    */
  function resetModal() {
    setSubmitted(false);
    setModalError('');
    setTickerMessage('');
    setZone('');
  }

  useEffect(() => {
    const modalElement = document.getElementById('tickerMessageModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);

  useEffect(() => {
    if (zone !== SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER) return;
    if (tickerMessageData && tickerMessageData.content && tickerMessageData.content.message) {
      setTickerMessage(tickerMessageData.content.message);
    } 
    else {
      setTickerMessage('');
    }
  }, [tickerMessageData,zone]);

  /**
   * Handle form input change
   */
const handleChange = useCallback((e) => {
    const value = e.target.value;

    if (value.length <= MAX_CHARACTERS) {
      setTickerMessage(value);
    }

    if (value.length < 2) {
      setTickerMessageValid("TICKER_MESSAGE_LENGTH");
    } else {
      setTickerMessageValid('');
    }
  }, []);

  const handleAdd = async () => {
    try {
      setZoneData((prevZoneData) => {
        const newZoneData = { ...prevZoneData };
        newZoneData[zone] = {
          zone: zone,
          content: {
            message: tickerMessage.trim()
          }
        };
        return newZoneData;
      });
      markUnsavedChanges && markUnsavedChanges();
      setSuccess(<FormattedMessage id="TICKER_MESSAGE_SUCCESS" />);
      closeModal("tickerMessageModal");
      resetModal();
    } catch (err) {
      setModalError(<FormattedMessage id="TICKER_MESSAGE_SUCCESS" values={{ errorMsg: <b>{err.message}</b> }} />);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const name = tickerMessage.trim();
    if (name.length < 2 || name.length > MAX_CHARACTERS) {
      setTickerMessageValid("TICKER_MESSAGE_LENGTH");
      setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
      return;
    }
    handleAdd();
  };

  return (
    <div className='modal modal-mse fade' id='tickerMessageModal' tabIndex='-1' aria-labelledby='tickerMessageModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='TICKER_MESSAGE' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className='mb-2'>
                  <label htmlFor='typeMessageInput' className='font-weight-600 font-size-14 mb-2'>
                    <FormattedMessage id='TYPE_MESSAGE' />:
                  </label>
                  <input
                    id="typeMessageInput"
                    onChange={handleChange}
                    value={tickerMessage}
                    name='typeMessage'
                    placeholder={t('TYPE_MESSAGE')}
                    className={`form-control h-54 bg-baby-blue ${submitted && (tickerMessageValid ? 'is-invalid' : 'is-valid')}`}
                  />
                  {commonFunctions.InvalidFeedbackString(tickerMessageValid, 'TYPE_MESSAGE')}
                  <small className="text-muted mt-1">
                    {MAX_CHARACTERS - tickerMessage.length} <FormattedMessage id="CHARACTERS_REMAINING" />
                  </small>
                </div>
                {submitted && modalError && (
                  <div className='modal-error invalid-feedback d-block fw-bold text-center'>
                    {modalError}
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backGroupModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveGroupBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit}>
              <FormattedMessage id='ADD_TICKER_MESSAGE' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TickerMessage;
